import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import AddIcon from '@material-ui/icons/Add';

import Boton from '../../commons/Boton';
import CheckBox from '../../commons/CheckBox';
import Modal from '../../commons/Modal';
import Texto from '../../commons/Texto';

const ProcedimientoDetail = ({ selected, onClose, onSend }) => {
  const [detail, setDetail] = useState(selected);

  const { tipoDatos } = useSelector((state) => state.detalle);

  useEffect(() => {
    let exist = tipoDatos.find((t) => t.de === selected.de);
    if (exist) {
      handleChange({ name: 'td', value: exist.dt });
    }
  }, []);

  const handleChange = (item) => {
    const { name, value } = item;
    setDetail((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <Modal
      title={`${selected.co ? 'Editar' : 'Nuevo'} procedimiento unitario`}
      onActions={() => (
        <Boton
          className="op-dinamic"
          icon={() => <AddIcon />}
          tabIndex={22}
          style={{ '--button-color': '#3285a8' }}
          onClick={() => onSend(detail)}
        >
          {`${selected.co ? 'Editar' : 'Agregar'} procedimiento Unitario`}
        </Boton>
      )}
      closeWithoutConfirmation
      onClose={() => onClose()}
      size="small"
    >
      <Texto
        name="np"
        value={detail.np}
        label="Nombre"
        tabIndex={20}
        onChange={handleChange}
      />
      {detail.co && (
        <div className="op-form-group op-checkbox-group">
          <span>Estado del registro</span>
          <CheckBox
            name="st"
            tabIndex={21}
            checked={detail.st}
            onChange={handleChange}
          />
        </div>
      )}
    </Modal>
  );
};

export default ProcedimientoDetail;
